import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReservationformComponent } from './reservationform/reservationform.component';
import { ForgotPasswordPageComponent } from './forgot-password/forgot-password-page.component';
import { ResetPasswordPageComponent } from './reset-password/reset-password-page.component';
import { TicketPaymentComponent } from './ticket-payment/ticket-payment.component';
import { GuestGuard } from '@foh/shared/auth/guest-guard.service';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { DepositPaymentComponent } from './deposit-payment/deposit-payment.component';
import { TicketManagementComponent } from './ticket-management/ticket-management.component';
import { DisplayQrcodeComponent } from './display-qrcode/display-qrcode.component';
import { NewreservationformComponent } from './newreservationform/newreservationform.component';
import { ManageReservationComponent } from './manage-reservation/manage-reservation.component';
import { CreditcardsManagementComponent } from './creditcards-management/creditcards-management.component';
import { GuestLoginComponent } from './guest-login/guest-login.component';
import { GuestLoggedinAreaComponent } from './guest-loggedin-area/guest-loggedin-area.component';
import { GuestCreateprofileComponent } from './guest-createprofile/guest-createprofile.component';
import { GuestEditprofileComponent } from './guest-editprofile/guest-editprofile.component';
import { CustomerGuestGuard } from '@foh/shared/auth/customer-guest-guard.service';
import { CustomerAuthGuard } from '@foh/shared/auth/customer-auth-guard.service';

const routes: Routes = [
  {
    path: 'guest/login/:token',
    component: GuestLoginComponent ,
    canActivate: [CustomerGuestGuard],
    data: {
      title: 'Guest Login'
    },
  },
  {
    path: 'guest/create-profile/:token',
    component: GuestCreateprofileComponent ,
    canActivate: [CustomerGuestGuard],
    data: {
      title: 'Guest Create Profile'
    },
  },
  {
    path: 'guest/myprofile/:token',
    component: GuestLoggedinAreaComponent,
    canActivate: [CustomerAuthGuard],
    data: {
      title: 'Guest Profile'
    },
  },
  {
    path: 'guest/edit-profile/:token',
    component: GuestEditprofileComponent ,
    canActivate: [CustomerAuthGuard],
    data: {
      title: 'Guest Create Profile'
    },
  },
  {
    path: 'reservation-form-canceled/:token/:fbid',
    component: ReservationformComponent ,
    data: {
      title: 'Reservation Form'
    },
  },
  {
    path: 'reservation-form/:token',
    component: NewreservationformComponent,
    data: {
      title: 'Reservation Form'
    },
  },
  {
    path: 'reservation-form/:token/:fbid',
    component: NewreservationformComponent,
    data: {
      title: 'Reservation Form'
    },
  },
  {
    path: 'manage-reservation/:refcode',
    component: ManageReservationComponent,
    data: {
      title: 'Reservation Form'
    },
  },
  {
    path: 'manage-reservation/:refcode/:fbid',
    component: ManageReservationComponent,
    data: {
      title: 'Reservation Form'
    },
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordPageComponent ,
    canActivate: [GuestGuard],
    data: {
      title: 'Forgot Your Password'
    },
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordPageComponent ,
    canActivate: [GuestGuard],
    data: {
      title: 'Reset Password'
    },
  },
  {
    path: 'pay-tickets/:token/:ticketid',
    component: TicketPaymentComponent,
    data: {
      title: 'Pay Tickets'
    },
  },
  // {
  //   path: 'pay-tickets/:token/:ticketid/:orderid',
  //   component: TicketPaymentComponent,
  //   data: {
  //     title: 'Pay Tickets'
  //   },
  // },
  {
    path: 'manage-tickets/:token',
    component: TicketManagementComponent,
    data: {
      title: 'Manage Tickets'
    },
  },
  {
    path: 'manage-creditcards/:token',
    component: CreditcardsManagementComponent,
    data: {
      title: 'Manage Credit Cards'
    },
  },
  {
    path: 'ticket-qrcode/:token/:ticketrefid',
    component: DisplayQrcodeComponent,
    data: {
      title: 'Display QR Code'
    },
  },
  {
    path: 'pay-deposit/:token',
    component: DepositPaymentComponent,
    data: {
      title: 'Pay Deposit'
    },
  },
  {
    path: 'pay-deposit/:token/:orderid',
    component: DepositPaymentComponent,
    data: {
      title: 'Pay Deposit'
    },
  },
  {
    path: 'terms-conditions/:code',
    component: TermsConditionsComponent,
    data: {
      title: 'Terms & Conditions'
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicpagesRoutingModule { }
